export function pickDefaultTemplateId(
  templates: Array<{ id: string }>,
): string {
  return templates[0]?.id ?? '';
}

export function pickDefaultMailTemplateId(
  templates: Array<{ id: string; locale?: string }>,
  preferredLocale: string,
): string {
  return (
    templates.find((template) => template.locale === preferredLocale)?.id ??
    templates[0]?.id ??
    ''
  );
}
